export default {
  imageUrlB64: "",
};
